(function () {
  function hideFloatingAtcBars() {
    var bars = document.querySelectorAll('.dgz-atc-bar, #dgzAtcBar');
    bars.forEach(function (bar) {
      bar.style.transition = 'opacity .2s ease, transform .2s ease';
      bar.style.opacity = '0';
      bar.style.pointerEvents = 'none';
      bar.style.transform = 'translateY(100%)';
      bar.setAttribute('aria-hidden', 'true');
    });
    if (bars.length) {
      document.body.style.paddingBottom = '';
    }
  }

  // Checks the REAL cart state (not just this tab/session) and hides the
  // floating bar if the product is already in the cart. This covers the
  // case where the customer leaves the store and comes back later.
  function checkCartAndHideIfNeeded() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (cart && cart.item_count > 0) {
          hideFloatingAtcBars();
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkCartAndHideIfNeeded);
  } else {
    checkCartAndHideIfNeeded();
  }

  if (!window.__dgzAtcAutoHidePatched) {
    window.__dgzAtcAutoHidePatched = true;

    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var target = args[0];
      var targetUrl = (typeof target === 'string') ? target : (target && target.url) || '';
      var promise = origFetch.apply(this, args);
      if (targetUrl.indexOf('/cart/add') !== -1) {
        promise.then(function (res) {
          if (res && res.ok) {
            hideFloatingAtcBars();
          }
        }).catch(function () {});
      }
      return promise;
    };

    document.addEventListener('submit', function (evt) {
      var form = evt.target;
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
        hideFloatingAtcBars();
      }
    }, true);

    // Also re-check whenever the page becomes visible again (e.g. user
    // switches back to this tab, or returns via back/forward cache).
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        checkCartAndHideIfNeeded();
      }
    });
    window.addEventListener('pageshow', function (evt) {
      if (evt.persisted) {
        checkCartAndHideIfNeeded();
      }
    });
  }

  function updateFloatingBarPrice(sectionId, html) {
    if (!html || !sectionId) return;
    var priceWrapper = html.getElementById('price-' + sectionId);
    if (!priceWrapper) return;

    var priceEl = priceWrapper.querySelector('.price');
    var isOnSale = !!(priceEl && priceEl.classList.contains('price--on-sale'));
    var selector = isOnSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular';
    var priceTarget = priceWrapper.querySelector(selector);
    if (!priceTarget) return;

    var priceText = priceTarget.textContent.replace(/\s+/g, ' ').trim();
    if (!priceText) return;

    document.querySelectorAll('.dgz-atc-price').forEach(function (el) {
      el.textContent = priceText;
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      try {
        var payload = event && event.data ? event.data : {};
        updateFloatingBarPrice(payload.sectionId, payload.html);
      } catch (err) {}
    });
  }
})();
